module.exports = __webpack_public_path__ + "static/media/money.2a62c404.svg";